import { render, staticRenderFns } from "./AdditionalFiles.vue?vue&type=template&id=09cbf0c3&scoped=true"
import script from "./AdditionalFiles.vue?vue&type=script&lang=js"
export * from "./AdditionalFiles.vue?vue&type=script&lang=js"
import style0 from "./AdditionalFiles.vue?vue&type=style&index=0&id=09cbf0c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cbf0c3",
  null
  
)

export default component.exports